import * as React from 'react';
import { useAppDispatch } from '../../appStore';
import { getEmailTemplates } from '../../store/EmailTemplateSlice';

export interface IEmailTemplateLoaderProps {
	surveyId: number;
	audienceId: number;
}

export const EmailTemplateLoader = (props: IEmailTemplateLoaderProps) => {
	const dispatch = useAppDispatch();
	React.useEffect(() => {
		if (props.audienceId !== 0) {
			dispatch(getEmailTemplates({ surveyId: props.surveyId, audienceId: props.audienceId }));
		}
	}, [dispatch, props.surveyId, props.audienceId]);

	return <> </>;
};
